


import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { LangProvider } from './i18n/LangContext';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <AppRoutes />
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
